import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'sortBy'
})
export class SortByPipe implements PipeTransform {
  transform(value: any[], property: string, order: string = 'asc'): any[] {
    if (!Array.isArray(value) || !property || !order) {
      return value;
    }

    return value.sort((a, b) => {
      const aValue = a[property];
      const bValue = b[property];

      let comparison = 0;
      if (aValue > bValue) {
        comparison = 1;
      } else if (aValue < bValue) {
        comparison = -1;
      }

      return order === 'desc' ? comparison * -1 : comparison;
    });
  }
}
